import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 1rem;
`;

export const Input = styled.input`
  color: #526571;
  border: none;
  border-bottom: 1px solid #526571;
  display: block;
  width: 100%;
  outline: none;
  padding: 0.5rem 0;
`;
